import { useMemo } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import { formatModelCode } from '../utils/modelCategoryRanges';

const ProductMediaViewer = ({
  open,
  onClose,
  item,
  images,
  initialIndex = 0,
  onIndexChange,
  onAddToCart,
  addToCartLabel = 'Add to Cart',
  displayName,
}) => {
  const safeSlides = useMemo(() => (
    Array.isArray(images) && images.length > 0
      ? images
      : [{ src: '/logo.png' }]
  ), [images]);

  return (
    <>
      <Lightbox
        open={open}
        close={onClose}
        slides={safeSlides}
        index={initialIndex}
        on={{
          view: ({ index }) => {
            if (onIndexChange) {
              onIndexChange(index);
            }
          }
        }}
        plugins={[Zoom, Thumbnails]}
        zoom={{
          maxZoomPixelRatio: 4,
          zoomInMultiplier: 2,
          doubleTapDelay: 300,
          doubleClickDelay: 300,
          wheelZoomDistanceFactor: 120
        }}
        thumbnails={{
          position: 'bottom',
          width: 80,
          height: 60,
          border: 1,
          borderRadius: 6
        }}
        carousel={{ finite: safeSlides.length <= 1 }}
      />

      <div className="fixed bottom-0 left-0 right-0 z-[1000] bg-black/75 backdrop-blur-md p-4 sm:p-6 pointer-events-none">
        <div className="container mx-auto pointer-events-auto">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="text-white">
              <h2 className="text-xl sm:text-2xl font-semibold mb-1">{displayName || item?.modelName || 'Product Preview'}</h2>
              <p className="text-gray-300 text-sm sm:text-base mb-1">
                {item?.modelNumber
                  ? `Model ${formatModelCode(item.size ?? item.category, item.modelNumber)}`
                  : 'Model details unavailable'}
              </p>
              <p className="text-xl sm:text-2xl font-bold text-orange-400">
                {typeof item?.price === 'number' ? `₹${item.price.toLocaleString('en-IN')}` : 'Price unavailable'}
              </p>
              <p className="text-sm text-gray-400 mt-1">
                {typeof item?.currentStock === 'number'
                  ? `Stock: ${item.currentStock} available`
                  : 'Stock details unavailable'}
              </p>
            </div>

            <button
              onClick={onAddToCart}
              className="bg-stone-100 text-stone-900 px-5 py-3 rounded-xl font-semibold hover:bg-white transition-colors flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l-1.5 3m3-3l1.5-3M12 13v6m0 0h3m-3 0h-3" />
              </svg>
              {addToCartLabel}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductMediaViewer;
